import { Alert } from '@mui/material';
import { useParams, useSearchParams } from 'react-router';

import { PageContainer, PageHeading } from '@/components/layout';

/**
 * Wizard Execution Details page - shows detailed logs for wizard executions
 * Similar to ExecutionDetails but specifically for wizards
 *
 * URL: /a/:appId/wiz/health?executionGuid=xxx&env=xxx
 */
export const WizardExecutionDetailsPage = () => {
  const { appId } = useParams<{ appId: string }>();
  const [searchParams] = useSearchParams();

  const executionGuid = searchParams.get('executionGuid');
  const environmentId = searchParams.get('env');

  if (!executionGuid) {
    return (
      <PageContainer>
        <PageHeading title="Wizard Execution Details" />
        <Alert severity="warning">
          No execution GUID provided. Please access this page from the wizard executions list.
        </Alert>
      </PageContainer>
    );
  }

  // TODO: Implement wizard-specific execution details once the API is available
  // For now, show a placeholder with the execution GUID
  return (
    <PageContainer>
      <PageHeading
        title="Wizard Execution Details"
        subtitle={`Execution GUID: ${executionGuid}${environmentId ? ` • Environment: ${environmentId}` : ''}`}
      />
      <Alert severity="info">
        Wizard execution details view is coming soon. For now, use the regular execution details
        page at{' '}
        <code>
          /a/{appId}/health?executionGuid={executionGuid}
        </code>
      </Alert>
    </PageContainer>
  );
};
